export default __webpack_public_path__ + "static/color-interaction-states-icons-light-105dbf20be94d1666baf3f2c6359bcde.png";